import React from 'react';
import { Modal } from 'carbon-components-react';
import { InlineLoading } from 'carbon-components-react';
require('./_quest.scss');

const QuestModal = (props) => {
    return (
        <div>
            <Modal
                className='quest-modal'
                passiveModal
                open={props.showQuestModal}
                onRequestClose={() => { props.toggleQuestModal(); }}
                size="sm">
                <div className="quest-container">
                    {props.questLoading ?
                        <div className="quest-loading">
                            <InlineLoading />
                        </div>
                        :
                        ''
                    }
                    <iframe
                        className={props.questLoading ? 'hide' : ''}
                        src="https://quest.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/component-injection-framework/questConversation?pageId=conversation&realm=JBPMSTG&application="
                        width="100%"
                        height="700"
                        onLoad={props.onQuestLoad}
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                    />
                    {/* {props.questLoading ?
                        <div className="quest-loading">
                            <InlineLoading />
                        </div>
                        :
                        <iframe
                            src="http://9.46.86.39:8082/component-injection-framework/questConversation?pageId=conversation&realm=local&application="
                            width="100%"
                            height="700"
                            onLoad={props.onQuestLoad}
                            frameBorder="0"
                            marginHeight="0"
                            marginWidth="0"
                        />
                    } */}
                </div>
            </Modal>
        </div>
    )
};

export default QuestModal;
